export enum InfoBoxType {
  GREEN,
  ORANGE,
  BLUE,
  RED,
}

export enum InfoBoxIconType {
  RED_X,
  GREEN_CHECK,
  EXCLAMATION,
  INFORMATION,
}
